//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MainImage from '~/components/atoms/Editorial/MainImage.vue';
export default {
  name: 'ProductCard',
  components: {
    MainImage
  },
  props: {
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    reference: {
      type: String,
      default: ''
    },
    stock: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    },
    salePrice: {
      type: String,
      default: ''
    },
    ecopart: {
      type: String,
      default: ''
    },
    quantity: {
      type: String,
      default: ''
    }
  }
};